module.exports = __webpack_public_path__ + "static/media/barber-hero.1aef2b73.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/barber-hero.jpg
// module id = 1818
// module chunks = 0